import React from 'react';
import '../../../css/admin/chats/EventNotes.css';
import ChatNotesPanel from '../../common/chat/notes/ChatNotesPanel';

const API_URL = process.env.REACT_APP_API_URL;

const EventNotesPanel = ({ eventId, onModeChange, onNotesChanged, canCreateNote = true, canManageNotes = true }) => (
  <ChatNotesPanel
    ownerId={eventId}
    rootClassName="admin-notes-panel"
    title="ノート"
    buildListUrl={(ownerId, offset = 0, limit = 20) => `${API_URL}/api/admin/event-notes/${ownerId}?offset=${offset}&limit=${limit}`}
    createUrl={`${API_URL}/api/admin/event-notes`}
    buildUpdateUrl={(noteId) => `${API_URL}/api/admin/event-notes/${noteId}`}
    buildDeleteUrl={(noteId) => `${API_URL}/api/admin/event-notes/${noteId}`}
    buildDetailUrl={(noteId) => `${API_URL}/api/event-notes/detail/${noteId}`}
    onModeChange={onModeChange}
    onNotesChanged={onNotesChanged}
    canCreateNote={canCreateNote}
    canManageNotes={canManageNotes}
    openDetailEventName="admin-notes-open-detail"
    closeDetailEventName="admin-notes-close-detail"
    closeImageEventName="admin-notes-close-image"
  />
);

export default EventNotesPanel;
